module.exports = __webpack_public_path__ + "img/user_icon.731824a6.png";